module.exports = __webpack_public_path__ + "img/bici.ce98a7b5.svg";